import styled from "styled-components";

import { Select } from "antd";

export const LSUnderLineSelect = styled(Select)`
    .ant-select-selector {
        border-radius: 0;
        border-top: none !important;
        border-left: none !important;
        border-right: none !important;

        .ant-select-selection-placeholder {
            font-style: italic;
        }
    }

    &.ant-select-focused {
        .ant-select-selector {
            box-shadow: none !important;
        }
    }
`;